'use strict';

/* globals FB */

/* eslint indent: ["error", 2, { "MemberExpression": 0 }] */
/* eslint consistent-this: [2, "vm"] */

const SocialLoginService = function ($timeout, $window, sbAuth, GClient, IdentityService) {

  var vm = this;
  vm.errorMessage = 'Unable to connect to the service. Please try again.';
  vm.googleAuthInitialized = false;
  vm.googleAuthClient = IdentityService.get('googleAuthAppId');
  vm.googleAuthLoaded = false;
  vm.googleAuthScope = 'email profile';

  vm.isGoogleLoggedIn = () => {

    return vm.loadGoogle()
    .then(() => {

      return $window.gapi.auth2.getAuthInstance().isSignedIn.get();
    });
  };

  vm.isFacebookLoggedIn = () => {

    return vm.loadFacebook()
    .then(() => {

      return new Promise((resolve) => {

        FB.getLoginStatus((response) => {

          resolve(response.status === 'connected');
        })
        .catch((err) => {

          resolve(false);
        });
      });
    })
    .catch((err) => {

      return false;
    });
  };

  vm.facebookAuth = (data, immediateLogin) => {

    data = data || {};
    if (immediateLogin) {
      return new Promise((resolve, reject) => {

        FB.getLoginStatus((response) => {

          if (response.status === 'connected') {
            const params = Object.assign({}, data, response);
            sbAuth.authenticateFacebook(params,
              (result) => {

                resolve(result);
              },
              (error) => {

                reject(error);
                // If the auth server returned an error, we need to log out the user
                FB.logout();
              }
            );
          }
          else {
            resolve();
          }
        });
      });
    }

    return new Promise((resolve, reject) => {

      FB.login((response) => {

        if (response.status === 'connected') {
          const params = Object.assign({}, data, response);
          sbAuth.authenticateFacebook(params,
            (result) => {

              resolve(result);
            },
            (error) => {

              reject(error);
            }
          );
        }
        else {

          resolve(null);
        }
      }, {
        scope: 'public_profile,email'
      });
    });
  };

  // Google sign in flow based on https://developers.google.com/api-client-library/javascript/samples/samples#authorizing-and-making-authorized-requests
  // using auth2 client library
  vm.googleAuth = (data, immediateLogin) => {

    data = data || {};
    if (immediateLogin) {
      const authResponse = $window.gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse();
      const params = Object.assign({}, data, {
        idToken: authResponse.id_token
      });
      return sbAuth.authenticateGoogle(params, () => {

        // OK
      }, () => {

        // If the auth server returned an error, we need to log out the user
        $window.gapi.auth2.getAuthInstance().signOut();
      });
    }

    let authPromise;

    // Trick for knowing when the auth popup was closed
    // See https://github.com/google/google-api-javascript-client/issues/25
    ((wrapped) => {
      window.open = function() {
        // Re-assign the original window.open after one usage
        window.open = wrapped;

        const win = wrapped.apply(this, arguments);
        const i = setInterval(() => {
          if (win.closed) {
            clearInterval(i);
            // cancel has no effect when the promise is already resolved, e.g. by the success handler
            // see http://docs.closure-library.googlecode.com/git/class_goog_Promise.html#goog.Promise.prototype.cancel
            $timeout(() => {
              // Add a timeout since we need the auth listener to fire before the close window
              authPromise.cancel();
            }, 1000);
          }
        }, 100);
        return win;
      };
    })(window.open);

    authPromise = $window.gapi.auth2.getAuthInstance().signIn({
      scope: vm.googleAuthScope,
      prompt: 'login', // See https://openid.net/specs/openid-connect-basic-1_0.html#RequestParameters
    });

    return new Promise((resolve) => {

      $window.gapi.auth2.getAuthInstance().isSignedIn.listen((status) => {

        if (status) {
          const authResponse = $window.gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse();
          resolve(authResponse);
        }
        else {
          resolve(null);
        }
      });

      authPromise.then(() => {

        // NOOP, we have the listener in place
      }, () => {

        // We are here because promise was cancelled, i.e. popup was closed
        resolve(null);
      });
    })
    .then((result) => {

      return new Promise((resolve, reject) => {

        if (result) {
          const params = Object.assign({}, data, {
            idToken: result.id_token
          });
          return sbAuth.authenticateGoogle(params, (result) => {

            resolve(result);
          }, (err) => {

            reject(err);
            // If the auth server returned an error, we need to log out the user
            $window.gapi.auth2.getAuthInstance().signOut();
          });
        }
        else {
          // Bubble resolve null to indicate cancellation
          resolve(null);
        }
      });
    });
  };

  vm.loadGoogle = () => {

    // vm ensures that we load the library first. We can get rid of the GClient
    // by using the onload callbacks provided in the url
    return GClient.get()
    .then(() => {

      return new Promise((resolve) => {

        if (vm.googleAuthLoaded) {
          resolve();
        }
        else {
          $window.gapi.load('client:auth2', () => {

            vm.googleAuthLoaded = true;
            resolve();
          });
        }
      });
    })
    .then(() => {

      if (vm.googleAuthInitialized) {
        return true;
      }
      else {
        return $window.gapi.client.init({
          clientId: vm.googleAuthClient,
          scope: vm.googleAuthScope
        })
        .then(() => {

          vm.googleAuthInitialized = true;
        });
      }
    });
  };

  vm.loadFacebook = () => {

    return new Promise((resolve) => {

      if ($window.FB && $window.FB.init) {
        resolve();
      }
      else {
        $window.fbAsyncInit = () => {

        // Executed when the SDK is loaded
          FB.init({
            /*
             The app id of the web app
            */
            appId: IdentityService.get('facebookAuthAppId'),
            /*
             Adding a Channel File improves the performance
             of the javascript SDK, by addressing issues
             with cross-domain communication in certain browsers.
            */
            channelUrl: './vendor/channel.html',
            /*
             Set if you want to check the authentication status
             at the start up of the app
            */
            status: true,
            /*
             Enable cookies to allow the server to access
             the session
            */
            cookie: false,
            /* Parse XFBML */
            xfbml: true,
            oauth: true,
            version: 'v3.0'
          });
          resolve();
        };
        (function(d, s, id){
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {return;}
          js = d.createElement(s); js.id = id;
          js.src = '//connect.facebook.net/en_US/sdk.js';
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
      }
    });
  };

  vm.logout = () => {

    // If an error occurs logging out the user, don't try to stop the skycatch logout process
    // so ignore the catch

    return new Promise((resolve) => {

      return vm.loadGoogle()
      .then(resolve)
      .catch(resolve);
    })
    .then(() => {

      const auth2 = $window.gapi.auth2.getAuthInstance();
      if (auth2.isSignedIn.get()) {
        return auth2.signOut().catch((err) => {
          return Promise.resolve();
        });
      }
      return Promise.resolve();
    })
    .then(() => {

      return new Promise((resolve) => {
        return vm.loadFacebook()
        .then(resolve)
        .catch(resolve);
      });
    })
    .then(() => {
      return new Promise((resolve) => {
        return vm.isFacebookLoggedIn()
        .then((isLoggedIn) => {

          if (!isLoggedIn) {
            resolve();
          }

          try {
            FB.logout((response) => {
              resolve(response);
            });
          }
          catch (err) {
            console.error(err);
            resolve();
          }
        })
        .catch((err) => {

          console.error(err);
          resolve();
        });
      });
    });
  };
};

SocialLoginService.$inject = ['$timeout', '$window', 'sbAuth', 'GClient', 'IdentityService'];

module.exports = SocialLoginService;



// WEBPACK FOOTER //
// ./src/app/login/services/SocialLoginService.js